import {Directive, HostListener, output} from "@angular/core";

@Directive({
    selector: "[focus-out-directive]",
    standalone: false
})
export class FocusOutDirective {
    readonly onFocusOut = output<boolean>();

    @HostListener("window:keydown.control.shift.f", ["$event"])
    @HostListener("mouseleave", ["$event"])
    public onListenerTriggered(event: any): void {
        this.onFocusOut.emit(true);
    }

    @HostListener("mouseenter", ["$event"])
    public onListenerTriggeredMouseOver(event: any): void {
        this.onFocusOut.emit(false);
    }
}
